import { Component, Watch } from 'vue-property-decorator';
import UrlMixin from '@/components/query/url-mixin';
import { mixins } from 'vue-class-component';
import { DelimitersEnum } from '@/services/models/Enums';
import GetUsingTypeMixin from '@/i18n/getUsingType-mixin';
import MetricsMixin from '@/views/reports/pickers/base/metrics-mixin';

@Component
export default class MenuBase extends mixins(UrlMixin,MetricsMixin,GetUsingTypeMixin) {
  maxSimultaneouslyDrilldownCount: number = 50;
  maxTotalDrilldownCount: number = 100;

  is(what: string) {
    return this.computedType === what;
  }

  get drlldownMaxSimultaneouslyCondintion() {
    return  this.$store.state.table.selectedItems.length > this.maxSimultaneouslyDrilldownCount;
  }

  get drlldownMaxTotalCondintion() {
    const drilldownTotal = this.drilldown
      .map((item) => {
        if(item.filterValues.includes(DelimitersEnum.drillFilterOptions)) {
          const filterValues = item.filterValues.split(DelimitersEnum.drillFilterOptions);
          return filterValues.length;
        } else {
          return 1;
        }
      })
      .reduce((a, b) => a + b, 0);

    return  (this.$store.state.table.selectedItems.length + drilldownTotal) > this.maxTotalDrilldownCount;
  }

  checkDrildown() {
    if(this.drlldownMaxSimultaneouslyCondintion) {
      this.bus.emit('toast-error', this.t('The report can be created basing on {0} elements only', [ this.maxSimultaneouslyDrilldownCount ]));
    } else if(this.drlldownMaxTotalCondintion) {
      this.bus.emit('toast-error', this.t('The report can be created basing on {0} elements total', [ this.maxTotalDrilldownCount ]));
    }

    return !(this.drlldownMaxSimultaneouslyCondintion || this.drlldownMaxTotalCondintion);
  }

  report(item?: any, grouping?: string) {
    if(!this.checkDrildown()) {
      return
    }

    this.bus.emit('freeze-table');

    this.$helpers.afterBrowserRedraw(() => { 
      const reportLink = item && grouping
        ? this.getReportLink({
          tableNextReport: item,
          tableNextReportGroup: this.getGroupByMetric(grouping)
        })
        : this.reportLink;

      this.bus.emit('tab-add', reportLink);
    });
  }

  reportExclude(item?: any, grouping?: string) {
    if(!this.checkDrildown()) {
      return
    }

    this.bus.emit('freeze-table');

    this.$helpers.afterBrowserRedraw(() => { 
      const reportLink = this.getReportLink({
        tableNextReportGroup: this.getGroupByMetric(grouping),
        tableNextReportExclude: true
      })
  
      this.bus.emit('tab-add', reportLink);
    });
  }

  get isNotesVisible() {
    return this.is('campaigns') || this.reportDrillCampaign;
  }

  @Watch('$store.state.table.selectedItems')
  onSelectedItemsChanged(items) {
    if (this.notesPanelVisible && items.length !== 1) {
      this.notesPanelVisible = false
    }
  }

  get notesPanelVisible() {
    return this.$store.state.table.notesOpened;
  }

  set notesPanelVisible(value: boolean) {
    this.$store.commit('tableNotesOpened', value);
  }

  editDrilldownActionText(type: string) {
    switch(type) {
      case 'campaign':
      case 'campaigns':
        return this.t('Edit Campaign');

      case 'offer':
      case 'offers':
        return this.t('Edit Offer');

      case 'flow':
      case 'flows':
        return this.t('Edit Flow');

      case 'landing':
      case 'landings':
        return this.t('Edit Landing');

      case 'trafficSource':
      case 'trafficSources':
        return this.t('Edit Traffic Sources');

      case 'affiliateNetwork':
      case 'affiliateNetworks':
        return this.t('Edit Affiliate Network');

      case 'trackingDomain':
        return this.t('Edit Tracking Domain');

      default:
        return '';
    }
  }
}
